module.exports = __webpack_public_path__ + "static/media/quote-dweck-potential.c36a6155.png";